import CookieConsent from './CookieConsent'
import { getCookie, setCookie } from './utils/cookies'
import triggerEvent, {
  COOKIE_CONSENT_EVENT,
  COOKIE_SETTINGS_EVENT,
  TRIGGER_AND_CLOSE_MODAL_EVENT,
} from './utils/triggerEvent'
import CookieSettings from './CookieSettings'
import { getCookieConsentOptions } from './utils/options'
import './index.scss'

declare global {
  interface Window {
    taOpenCookieSettings: () => void
    taOpenCookieConsent: () => void
    disableConsent?: boolean
  }
}

function isCookieSet(cookieName: string) {
  return !!getCookie(cookieName)
}

function createGlobalFunctions() {
  window.taOpenCookieSettings = function () {
    triggerEvent(COOKIE_SETTINGS_EVENT)
  }

  window.taOpenCookieConsent = function () {
    triggerEvent(COOKIE_CONSENT_EVENT)
  }

  $('.ta-cookie-consent-settings').on('click', (e) => {
    if (e) {
      e.preventDefault()
    }
    window.taOpenCookieSettings()
  })

  $('.ta-cookie-consent').on('click', (e) => {
    if (e) {
      e.preventDefault()
    }
    window.taOpenCookieConsent()
  })
}

$(() => {
  // dichiaro le funzioni globali
  createGlobalFunctions()

  const { cookieName, eventName } = getCookieConsentOptions()

  // Setup dei listener
  document.addEventListener(COOKIE_SETTINGS_EVENT, () =>
    CookieSettings.getInstance()
  )

  document.addEventListener(COOKIE_CONSENT_EVENT, () =>
    CookieConsent.getInstance()
  )

  document.addEventListener(TRIGGER_AND_CLOSE_MODAL_EVENT, () => {
    const { cookieName, eventName } = getCookieConsentOptions()
    setCookie(cookieName, true)
    triggerEvent(eventName)
  })

  document.addEventListener(eventName, (e) => {
    // @ts-ignore
    console.log('consent triggered', e.detail)
  })

  if (window?.disableConsent) return

  // Check dei cookies
  if (isCookieSet(cookieName)) {
    triggerEvent(eventName)
  } else {
    CookieConsent.getInstance()
  }
})
